import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import React from 'react'

export enum TOAST_TYPES {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

interface IToastBodyProps {
  show: boolean
  type: TOAST_TYPES
  message: string
  renderBody?: Function
  onClose: Function
}

const theme = {
  type: {
    [TOAST_TYPES.SUCCESS]: {
      iconContainer:
        'flex justify-center items-center w-5 h-5 rounded-full bg-jade-50',
      icon: 'far fa-check text-jade-500 text-lg',
      progressBar: 'bg-jade-500 rounded-full',
    },
    [TOAST_TYPES.FAILURE]: {
      iconContainer:
        'flex justify-center items-center w-5 h-5 rounded-full bg-watermelon-50',
      icon: 'far fa-exclamation text-watermelon-500 text-lg',
      progressBar: 'bg-watermelon-500 rounded-full',
    },
  },
}

const ToastBody: React.FunctionComponent<IToastBodyProps> = ({
  show,
  type,
  message,
  renderBody,
  onClose,
}) => {
  return (
    <Transition
      show={show}
      appear
      as={React.Fragment}
      enter="transform ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="w-full max-w-sm bg-white rounded-md shadow-lg pointer-events-auto overflow-hidden mb-3">
        <div className="p-3">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <div className={theme.type[type]?.iconContainer}>
                <i className={theme.type[type]?.icon} />
              </div>
            </div>
            <div className="flex-1 ml-3">
              <p className="mt-1 text-oxford-gray-800 text-sm break-words">
                {message}
              </p>
            </div>
            {typeof renderBody === 'function' && renderBody()}
            <div className="flex flex-shrink-0 ml-4">
              <button
                className="inline-flex text-oxford-gray-800 hover:text-primary focus:outline-none"
                onClick={() => onClose()}
              >
                <span className="sr-only">Close</span>
                <i className="fal fa-times text-lg" />
              </button>
            </div>
          </div>
        </div>
        <Transition
          show
          appear
          as={React.Fragment}
          enter={`transition-width ease-linear duration-[4000ms]`}
          enterFrom="w-full"
          enterTo="w-0"
        >
          <div
            className={classNames([
              'h-[6px] float-right mb-1 mx-2',
              theme.type[type]?.progressBar,
            ])}
          />
        </Transition>
      </div>
    </Transition>
  )
}

export default ToastBody
